module.exports = __webpack_public_path__ + "img/settings.7fc027de.svg";